import MMetaVillaEnComp from './MMetaVillaEnComp';
import MMetaVillaComp from './MMetaVillaComp';
import MKboComp from './MKboComp';

export { MMetaVillaComp, MKboComp, MMetaVillaEnComp };